import { BulkImport, type BulkImportConfig, type Preview } from '../components/BulkImport';

/**
 * BULK IMPORT — students.
 *
 * ⚠ THE SCREEN ITSELF NOW LIVES IN components/BulkImport, because staff import the same way and
 * every detail on that screen was learned from something going wrong: the bearer token on the
 * template download, the revoked blob URL, the cap on the problem table, the refusal to do
 * arithmetic in the summary sentence. Two copies would agree today and drift by November.
 *
 * What remains here is the wording that is specific to children.
 */
const config: BulkImportConfig<Preview> = {
  eyebrow: 'Students',
  title: 'Import from a spreadsheet',
  intro: (
    <>
      Move your existing student list into Eduvora. Nothing is saved until you have seen exactly
      what will happen and pressed <strong>Import</strong>.
    </>
  ),
  basePath: '/api/students/import',
  templateFileName: 'eduvora-students-template.csv',
  noun: 'student',
  nounPlural: 'students',
  uploadHint: (
    <>
      Save as <strong>CSV UTF-8</strong> from Excel, not .xlsx. Only the admission number and the
      name are required.
    </>
  ),
  listTo: '/students',
  listLabel: 'students list',
};

export function StudentImportPage() {
  return <BulkImport config={config} />;
}
